import { defineComponent as _defineComponent } from 'vue'
import Wizard from '@/components/wizard/Wizard.vue';
import EquipmentSelectionWizardStep from './EquipmentSelectionWizardStep.vue';
import ApplicationSummaryWizardStep from './ApplicationSummaryWizardStep.vue';
import { useI18n } from '@/composables/i18n';
import {
  StandardAlertListItem,
  StandardAlertEligibleDevice,
} from '@/models/standardAlert';
import { computed, onMounted, ref } from 'vue';
import { standardAlertsService } from '@/services/standardAlerts.service';
import { toastService } from '@/library-services/toast.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'StandardAlertApplicationWizard',
  props: {
    standardAlerts: null
  },
  emits: ["close", "save"],
  setup(__props: any, { emit }: { emit: ((e: 'close' | 'save') => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  standardAlerts: StandardAlertListItem[];
};





const eligibleDevices = ref<StandardAlertEligibleDevice[]>([]);
const selectedDevices = ref<StandardAlertEligibleDevice[]>([]);
const loading = ref(false);
const applyToAllEquipment = ref(true);

const { t } = useI18n();

onMounted(() => {
  loadEligibleDevices();
});

async function loadEligibleDevices() {
  try {
    loading.value = true;
    eligibleDevices.value = await standardAlertsService.getEligibleDevices(
      props.standardAlerts,
    );
  } finally {
    loading.value = false;
  }
}

async function onSubmit() {
  await standardAlertsService.apply(props.standardAlerts, finalDevices.value);

  toastService.success(
    'e_service_center.standard_alert_application_wizard.success',
  );
  emit('close');
  emit('save');
}

const finalDevices = computed<StandardAlertEligibleDevice[]>(() =>
  applyToAllEquipment.value ? eligibleDevices.value : selectedDevices.value,
);

return { __sfc: true,props, emit, eligibleDevices, selectedDevices, loading, applyToAllEquipment, t, loadEligibleDevices, onSubmit, finalDevices, Wizard, EquipmentSelectionWizardStep, ApplicationSummaryWizardStep }
}

})